import React, { useState, useContext, useEffect, useRef } from "react";
import { Form, Col, Row, Container, Button } from "react-bootstrap";
import { keyUserId, keyAccessToken } from "../../assets/js/SessionStorageNames";
import { GlobalContext } from "../../contexts/GlobalContext";
import axios from "axios";
import { Redirect } from "react-router-dom";
import Routes from "../../Routes";
import verifyAccessRole from "../../assets/js/verifyAccessRole";
import DateTime from "../admin/cron-reports/components/DateTime";
import getAttribodoo from "../admin/plugins/woo/functions/getAttribOdoo";
import { Link } from "react-router-dom";

const ADMIN_SECTIONS = [
  { id: "section-sync", label: "Sincronizar" },
  {
    id: "section-downloads",
    label: "Descargas",
    children: [
      { id: "section-downloads-odoo", label: "Odoo" },
      { id: "section-downloads-ml", label: "Mercado Libre" },
      { id: "section-downloads-amazon", label: "Amazon" },
      { id: "section-downloads-others", label: "Otros" },
    ],
  },
  { id: "section-scrapping", label: "Scrapping" },
  { id: "section-nord", label: "Nord" },
  { id: "section-proxies", label: "Cuentas Proxys" },
  { id: "section-debugging", label: "Process debugging" },
  { id: "section-rbac", label: "RBAC" },
  { id: "section-others", label: "Otros" },
  { id: "section-odoo-owner", label: "Odoo Owner - Proveedores" },
];

const ADMIN_TRACKED_SECTION_IDS = ADMIN_SECTIONS.flatMap((section) =>
  section.children && section.children.length
    ? section.children.map((child) => child.id)
    : [section.id]
);

const NAV_SECTION_THEMES = {
  "section-sync": {
    accent: "#2563eb",
    activeBackground: "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)",
    activeText: "#ffffff",
    shadow: "rgba(37, 99, 235, 0.24)",
  },
  "section-downloads": {
    accent: "#0ea5e9",
    activeBackground: "linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%)",
    activeText: "#ffffff",
    shadow: "rgba(14, 165, 233, 0.22)",
  },
  "section-downloads-odoo": {
    accent: "#7c7bad",
    activeBackground: "linear-gradient(135deg, #7c7bad 0%, #6d28d9 100%)",
    activeText: "#ffffff",
    shadow: "rgba(109, 40, 217, 0.2)",
  },
  "section-downloads-ml": {
    accent: "#ffd000",
    activeBackground: "linear-gradient(135deg, #ffe600 0%, #ffd000 100%)",
    activeText: "#111827",
    shadow: "rgba(245, 158, 11, 0.2)",
  },
  "section-downloads-amazon": {
    accent: "#ff9900",
    activeBackground: "linear-gradient(135deg, #ff9900 0%, #f97316 100%)",
    activeText: "#111827",
    shadow: "rgba(249, 115, 22, 0.2)",
  },
  "section-downloads-others": {
    accent: "#64748b",
    activeBackground: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
    activeText: "#ffffff",
    shadow: "rgba(71, 85, 105, 0.2)",
  },
  "section-scrapping": {
    accent: "#f97316",
    activeBackground: "linear-gradient(135deg, #f97316 0%, #ea580c 100%)",
    activeText: "#ffffff",
    shadow: "rgba(234, 88, 12, 0.2)",
  },
  "section-nord": {
    accent: "#2563eb",
    activeBackground: "linear-gradient(135deg, #0ea5e9 0%, #2563eb 100%)",
    activeText: "#ffffff",
    shadow: "rgba(37, 99, 235, 0.22)",
  },
  "section-proxies": {
    accent: "#14b8a6",
    activeBackground: "linear-gradient(135deg, #14b8a6 0%, #0f766e 100%)",
    activeText: "#ffffff",
    shadow: "rgba(15, 118, 110, 0.2)",
  },
  "section-debugging": {
    accent: "#4f46e5",
    activeBackground: "linear-gradient(135deg, #4f46e5 0%, #4338ca 100%)",
    activeText: "#ffffff",
    shadow: "rgba(67, 56, 202, 0.22)",
  },
  "section-rbac": {
    accent: "#dc2626",
    activeBackground: "linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)",
    activeText: "#ffffff",
    shadow: "rgba(185, 28, 28, 0.2)",
  },
  "section-others": {
    accent: "#6366f1",
    activeBackground: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
    activeText: "#ffffff",
    shadow: "rgba(79, 70, 229, 0.2)",
  },
  "section-odoo-owner": {
    accent: "#7c3aed",
    activeBackground: "linear-gradient(135deg, #7c3aed 0%, #6d28d9 100%)",
    activeText: "#ffffff",
    shadow: "rgba(109, 40, 217, 0.2)",
  },
};

const MODERN_ADMIN_STYLES = `
.test-admin-page {
  background:
    radial-gradient(circle at top right, rgba(37, 99, 235, 0.10), transparent 28%),
    linear-gradient(180deg, #f8fbff 0%, #f4f7fb 100%);
  min-height: 100vh;
}

.test-admin-page .test-admin-sidebar,
.test-admin-page .test-admin-hero,
.test-admin-page .test-admin-section {
  backdrop-filter: blur(12px);
}

.test-admin-page .test-admin-sidebar {
  background: linear-gradient(180deg, rgb(231 231 231 / 52%) 0%, rgb(238 243 248 / 98%) 100%);
  display: flex;
  flex-direction: column;
  max-height: calc(100vh - 3rem);
  overflow: hidden;
}

.test-admin-page .test-admin-sidebar-nav {
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 0.35rem;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.test-admin-page .test-admin-sidebar-nav::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.test-admin-page .test-admin-sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(148, 163, 184, 0.45);
  border-radius: 999px;
}

.test-admin-page .test-admin-sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.test-admin-page .test-admin-hero {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.96) 0%, rgba(239, 246, 255, 0.95) 52%, rgba(238, 242, 255, 0.96) 100%) !important;
}

.test-admin-page .test-admin-section {
  position: relative;
  overflow: hidden;
}

.test-admin-page .test-admin-section > * {
  position: relative;
  z-index: 1;
}

.test-admin-page .test-admin-section-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.25rem;
  color: #0f172a;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.test-admin-page .test-admin-section-title::after {
  content: "";
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.45), transparent);
}

.test-admin-page .test-admin-subsection {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.94) 0%, rgba(248, 250, 252, 0.98) 100%);
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 18px;
  padding: 1.2rem 1.25rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.85);
}

.test-admin-page .test-admin-subsection-title {
  margin: 0 0 1rem;
  color: #475569;
  font-size: .95rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.test-admin-page .test-admin-section hr,
.test-admin-page .test-admin-subsection hr {
  display: none;
}

.test-admin-page .test-admin-section .row {
  row-gap: 1rem;
}

.test-admin-page .test-admin-section .btn {
  min-height: 46px;
  border-radius: 14px;
  font-weight: 600;
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 10px 22px rgba(15, 23, 42, 0.08);
}

.test-admin-page .test-admin-section .btn:not(.bg-success):not(.bg-danger):not(.bg-secondary) {
  background-image: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  border: none;
}

.test-admin-page .test-admin-section .btn.btn-info {
  background-image: linear-gradient(135deg, #06b6d4 0%, #0284c7 100%);
  border: none;
}

.test-admin-page .test-admin-section .form-control {
  min-height: 46px;
  border-radius: 14px;
  border: 1px solid rgba(100, 116, 139, 0.45);
  background: rgba(255, 255, 255, 0.95);
  box-shadow:
    inset 0 1px 2px rgba(15, 23, 42, 0.04),
    0 0 0 1px rgba(255, 255, 255, 0.55);
}

.test-admin-page .test-admin-section .form-control:focus {
  border-color: rgba(37, 99, 235, 0.6);
  box-shadow:
    0 0 0 3px rgba(37, 99, 235, 0.12),
    inset 0 1px 2px rgba(15, 23, 42, 0.04);
}

.test-admin-page .test-admin-section textarea.form-control {
  min-height: 150px;
}

.test-admin-page .test-admin-section .form-switch {
  padding: 0.35rem 0.5rem;
  border: 1px solid rgba(148, 163, 184, 0.16);
  border-radius: 14px;
  background: rgba(248, 250, 252, 0.85);
}

.test-admin-page .test-admin-section a {
  text-decoration: none;
}

.test-admin-page .test-admin-debug-link .btn {
  min-height: 52px;
  background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 14px 30px rgba(79, 70, 229, 0.24);
}

.test-admin-page .test-admin-debug-link .btn:hover,
.test-admin-page .test-admin-debug-link .btn:focus,
.test-admin-page .test-admin-debug-link .btn:active {
  background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 18px 34px rgba(67, 56, 202, 0.28);
}
`;

export default function TestAdmin() {
  const globalContext = useContext(GlobalContext);
  const [axiosCancelTokenSource] = useState(axios.CancelToken.source());
  const [inputs, setInputs] = useState({});
  const [redirect, setRedirect] = useState(null);
  const [pageReport, setPageReport] = useState(1);
  const [limitReport, setLimitReport] = useState(1000);
  const [dateReportUrl, setDateReportUrl] = useState("");
  const [activeSection, setActiveSection] = useState(ADMIN_SECTIONS[0].id);
  const [disableNavTransition, setDisableNavTransition] = useState(false);
  const navListRef = useRef(null);
  const scrollContainerRef = useRef(window);
  const updateActiveSectionRef = useRef(() => {});
  const isManualNavigationRef = useRef(false);
  const manualNavigationTimeoutRef = useRef(null);

  useEffect(() => {
    const navListElement = navListRef.current;

    if (!navListElement || !activeSection) return;

    const activeNavItem = navListElement.querySelector(
      `[data-nav-id="${activeSection}"]`
    );

    if (!activeNavItem) return;

    activeNavItem.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      behavior: "auto",
    });
  }, [activeSection]);

  // useEffect(() => {
  //     const hasAccess = verifyAccessRole(Routes, 64);
  //     if(!hasAccess) {
  //         setRedirect(
  //             <Redirect to={`/admin/dashboard`} />
  //         )
  //     }
  // },[]);

  /**
   * Handle the axios error
   * @param {Error} err The thrown error
   * @param {string} msg A message to show in the modal
   * @param {boolean} consoleLog If should log the error in the console
   */
  const handleAxiosError = (err, msg = null, consoleLog = true) => {
    if (axios.isCancel(err)) return; //Don't show axios cancel error

    if (err.response && err.response.data) {
      if (err.response.data.message) {
        globalContext.showModalWithMsg(err.response.data.message);
      } else {
        globalContext.showModalWithMsg(err.response.data);
      }
    } else if (msg) {
      globalContext.showModalWithMsg(msg);
    }

    if (consoleLog) console.log("Error: ", err, "Response: ", err.response);
  };

  const updateInputState = (e) => {
    const name = e.target.name;
    const newState = Object.assign({}, inputs);

    switch (e.target.type) {
      case "checkbox":
        newState[name] = e.target.checked;
        break;

      default:
        newState[name] = e.target.value;
        break;
    }

    setInputs(newState);
  };

  const downloadCategories = () => {
    if (!inputs.mlCountry) {
      globalContext.showModalWithMsg("El País de ML");
      return;
    }

    const processCheckIntervalTime = 5000;
    const headers = {
      "x-api-key": process.env.REACT_APP_API_KEY,
      "x-access-token": localStorage.getItem(keyAccessToken),
      "x-user-id": localStorage.getItem(keyUserId),
    };

    globalContext.setLoaderPage(true);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL
        }/v1/ml-category/sync/${inputs.mlCountry.toLowerCase()}`,
        {},
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;

        if (data.monitor) {
          //If the process ID was received, start monitoring
          let waitingMonitorResponse = false;
          const interval = setInterval(() => {
            if (!waitingMonitorResponse) {
              waitingMonitorResponse = true;

              axios
                .get(
                  `${process.env.REACT_APP_BACKEND_URL}/v1/process-monitor/${data.monitor}`,
                  {
                    cancelToken: axiosCancelTokenSource.token,
                    headers,
                  }
                )
                .then((resp) => {
                  const data = resp.data.data;

                  if (data.advance >= 100) {
                    clearInterval(interval);
                    globalContext.showModalWithMsg(`Se descargaron`);
                    globalContext.setLoaderPage(false);
                  } else {
                    const advance = data.advance.toFixed(2);
                    globalContext.setLoaderPage(
                      true,
                      `${advance}% (Categorias: ${data.data.savedCategories}/${data.data.totalCategories}) (Subcategorias: ${data.data.savedSubcategories}/?)`
                    );
                  }
                })
                .catch((err) => {
                  handleAxiosError(
                    err,
                    "Disculpe, no se pudo culminar la descarga de los productos."
                  );
                  clearInterval(interval);
                  globalContext.setLoaderPage(false);
                })
                .finally(() => {
                  waitingMonitorResponse = false;
                });
            }
          }, processCheckIntervalTime);
        } else {
          globalContext.setLoaderPage(false);
        }
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const downloadAmazonCategories = () => {
    if (!inputs.numAmazonLevel) {
      globalContext.showModalWithMsg("El numero de niveles");
      return;
    }

    const processCheckIntervalTime = 5000;
    const headers = {
      "x-api-key": process.env.REACT_APP_API_KEY,
      "x-access-token": localStorage.getItem(keyAccessToken),
      "x-user-id": localStorage.getItem(keyUserId),
    };

    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/parse-categories`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
          params: {
            maxDepth: inputs.numAmazonLevel,
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;

        if (data.monitor) {
          //If the process ID was received, start monitoring
          let waitingMonitorResponse = false;
          const interval = setInterval(() => {
            if (!waitingMonitorResponse) {
              waitingMonitorResponse = true;

              axios
                .get(
                  `${process.env.REACT_APP_BACKEND_URL}/v1/process-monitor/${data.monitor}`,
                  {
                    cancelToken: axiosCancelTokenSource.token,
                    headers,
                  }
                )
                .then((resp) => {
                  const data = resp.data.data;

                  if (data.advance >= 100) {
                    clearInterval(interval);
                    globalContext.showModalWithMsg(`Se descargaron`);
                    globalContext.setLoaderPage(false);
                  } else {
                    const advance = data.advance.toFixed(2);
                    globalContext.setLoaderPage(
                      true,
                      `${advance}% (Categorias: ${data.data.savedCategories}/${data.data.totalCategories})`
                    );
                  }
                })
                .catch((err) => {
                  handleAxiosError(
                    err,
                    "Disculpe, no se pudo culminar la descarga de los productos."
                  );
                  clearInterval(interval);
                  globalContext.setLoaderPage(false);
                })
                .finally(() => {
                  waitingMonitorResponse = false;
                });
            }
          }, processCheckIntervalTime);
        } else {
          globalContext.setLoaderPage(false);
        }
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const scrapAmazonCategoryNode = () => {
    const entId = globalContext.currentEnterpriseId;
    const cateId = inputs.categoryToScrap;
    const maxProdCount = inputs.numProdToScrapFromCategory;

    if (!entId) {
      globalContext.showModalWithMsg("La empresa...");
      return;
    } else if (!cateId) {
      globalContext.showModalWithMsg("La categoria...");
      return;
    } else if (!maxProdCount) {
      globalContext.showModalWithMsg("La cantidad de productos...");
      return;
    }

    const processCheckIntervalTime = 5000;
    let processModitorId = 0;
    const headers = {
      "x-api-key": process.env.REACT_APP_API_KEY,
      "x-access-token": localStorage.getItem(keyAccessToken),
      "x-user-id": localStorage.getItem(keyUserId),
    };

    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/${entId}/parse-category-products`,
        {
          headers,
          params: {
            cateId,
            maxProdCount,
          },
        }
      )
      .then((resp) => {
        globalContext.setLoaderPage(false);
        globalContext.showModalWithMsg(
          "El proceso se esta ejecutando en segundo plano"
        );
      })
      .catch((err) => handleAxiosError(err));
  };

  const updateMlUsers = () => {
    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/v1/ml-account/update-users`,
        {},
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const fixScrapMl = () => {
    const processCheckIntervalTime = 5000;
    let processModitorId = 0;
    const headers = {
      "x-api-key": process.env.REACT_APP_API_KEY,
      "x-access-token": localStorage.getItem(keyAccessToken),
      "x-user-id": localStorage.getItem(keyUserId),
    };

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/fix-ml`, {
        headers,
      })
      .then((resp) => {
        const data = resp.data.data;

        if (data.monitor) {
          processModitorId = data.monitor;

          //If the process ID was received, start monitoring
          let waitingMonitorResponse = false;
          const interval = setInterval(() => {
            if (!waitingMonitorResponse) {
              waitingMonitorResponse = true;

              axios
                .get(
                  `${process.env.REACT_APP_BACKEND_URL}/v1/process-monitor/${data.monitor}`,
                  {
                    cancelToken: axiosCancelTokenSource.token,
                    headers,
                  }
                )
                .then((resp) => {
                  const data = resp.data.data;

                  if (data.advance < 100) {
                    const advance = data.advance.toFixed(2);
                    globalContext.setLoaderPage(
                      true,
                      `${advance}% (${data.data.currentProd}/${data.data.totalProducts})`
                    );
                  } else {
                    globalContext.setLoaderPage(false);
                    clearInterval(interval);
                    globalContext.showModalWithMsg("Termino");
                  }
                })
                .catch((err) => {
                  handleAxiosError(err, "Disculpe, no se pudo culminar.");
                  clearInterval(interval);
                  globalContext.setLoaderPage(false);
                })
                .finally(() => {
                  waitingMonitorResponse = false;
                });
            }
          }, processCheckIntervalTime);
        } else {
          globalContext.setLoaderPage(false);
        }
      })
      .catch((err) => handleAxiosError(err));
  };

  const syncCurrencies = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/ml-currency/sync`,
        {},
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const syncCountries = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/ml-country/sync`,
        {},
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const startAmazonScrapCron = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/cron/start-scrap-amazon-scraped-products`,
        {},
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  /* useEffect(() => {
        setInterval(() => {
            axios.get(`${process.env.REACT_APP_BACKEND_URL}/v1/process-monitor/get-all`, {
                headers: {
                    "x-api-key": process.env.REACT_APP_API_KEY,
                    "x-access-token": localStorage.getItem(keyAccessToken),
                    "x-user-id": localStorage.getItem(keyUserId),
                },
            }).then(data => console.log("Respuesta: ", data.data.data)).catch(err => console.error("Fallo: ", err))
        }, 5000)
    }, []); */

  const syncNordServers = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/nord/sync-servers`,
        {},
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const nordVpnUser = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/v1/test/nordVpn`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
      })
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const getAmazonScrapConfig = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/config`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
      })
      .then((resp) => {
        console.log(resp.data);
        const newState = Object.assign({}, inputs);
        newState.amazonScrapConfig = JSON.stringify(
          resp.data.data.config,
          null,
          4
        );
        setInputs(newState);
      })
      .catch((err) => handleAxiosError(err));
  };

  const setAmazonScrapConfig = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/config`,
        {
          config: JSON.parse(inputs.amazonScrapConfig),
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const scrapedVariantToProduct = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/set-scraped-variant-as-product`,
        {},
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const addProxyAcc = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/proxy-acc/`,
        {
          brand: "NordVPN",
          enabled: true,
          user: inputs.proxyAccUser,
          maxConn: 6,
          pass: inputs.proxyAccPass,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };
  const sendMlProd = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/ml-product/ml-post-one-product-from-odoo`,
        {
          dataProd: {
            productId: "618d64c21f6cfbf9db5c6e54",
            title: "TEST DE ACEITUNAS PARA LF",
            price: 15,
            body: "descripcion de prueba",
            condition: "new",
            images: "algo",
            pausePublication: "paused",
            aditionalsParams: {
              brand: "algo",
              model: "test",
              width: "1",
              height: "1",
              length_prod: "1",
              weight: "1",
            },
          },
          entId: "5f0eaeb398c3f413782defb5",
          categoryMl: "61c9eb53a17fb2e14ef98bbc",
          listingType: "gold_special",
          officialStoreId: "933",
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const updateProxyAcc = () => {
    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/v1/proxy-acc/${inputs.proxyAccId}`,
        {
          pass: inputs.proxyAccPass,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const getProxyAcc = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/v1/proxy-acc/`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
        params: {
          pageNumber: 1,
          pageItemCount: 20,
        },
      })
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const disableProxyAcc = () => {
    axios
      .delete(
        `${process.env.REACT_APP_BACKEND_URL}/v1/proxy-acc/${inputs.proxyAccId}`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const delNoUrl = () => {
    axios
      .delete(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/delete-products-without-url`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const downloadCategoriesAnican = () => {
    globalContext.setLoaderPage(true);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/anicam/products/list`,
        {
          enterpriseId: "5f0eaeb398c3f413782defb5",
          page: 1,
          limit: 10,
          filter: {
            title: "Estufa",
          },
        },
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        globalContext.setLoaderPage(true);
        console.log("marcas anican", data);
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const testJesus = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/aliexp-prod/${globalContext.currentEnterpriseId}/cat`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        globalContext.setLoaderPage(true);
        console.log("marcas anican", data);
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const downloadodooCategories = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/odoo/odooCat`,
        {
          enterpriseId: globalContext.currentEnterpriseId,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };
  const donwloadAttrOdoo = () => {
    getAttribodoo(globalContext.currentEnterpriseId)
  }

  const removeBackground = () => {
    globalContext.setLoaderPage(true);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/clean-img/send-list-img-to-clean`,
        {
          listImgsBase64: "any hash on base64",
          enterpriseId: "5f0eaeb398c3f413782defb5",
        },
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        globalContext.setLoaderPage(false);
        console.log("data clean img", data);
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const sendCategoriesWoo = () => {
    globalContext.setLoaderPage(true);
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/woo-prod/create-categories`,
        {
          plugin: "AmazonScrap",
          enterpriseId: "60944575461add5b1957ef8b",
        },
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        globalContext.setLoaderPage(false);
        console.log("data clean img", data);
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const testKeepa = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-scrap/clean-prod-keepa/${globalContext.currentEnterpriseId}`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        globalContext.setLoaderPage(false);
        console.log("data keepa", data);
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const lodeml = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/test/update-no-translated`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const freeShipping = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/v1/test/update-shipping`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
      })
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const getDataPrice = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-report/pricesissues/${globalContext.currentEnterpriseId}/${pageReport}/${limitReport}`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };
  const downloadAllImg = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-image/${globalContext.currentEnterpriseId}/download-all-images`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const downloadAllImgVariants = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-image/${globalContext.currentEnterpriseId}/download-all-images-variants`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const downloadAllImgProduct = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/odoo-image/${globalContext.currentEnterpriseId}/download-all-images-products`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const getScrapedReport = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-report/scraped-url-by-acc-type/${dateReportUrl}`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
        globalContext.setLoaderPage(false);
        globalContext.showModalWithMsg("Se esjecuta en segundo plano");
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga de los productos."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const getRescrapedReport = () => {
    if (!dateReportUrl) {
      globalContext.showModalWithMsg("La fecha");
      return;
    }

    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-report/rescraped-by-ent/${dateReportUrl}`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
        globalContext.setLoaderPage(false);
        globalContext.showModalWithMsg("Se esjecuta en segundo plano");
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga del reporte."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const getRbacs = () => {
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/v1/rbac/`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
        params: {
          pageNumber: 1,
          pageItemCount: 10,
          filter: {
            free: null,
          },
        },
      })
      .then((resp) => console.log(resp.data))
      .catch((err) => handleAxiosError(err));
  };

  const getRbac = () => {
    const rbacRoute = inputs.rbacRoute;
    const method = inputs.rbacMethod;

    if (!rbacRoute && !method) {
      globalContext.showModalWithMsg("La ruta o el metodo esta vacia.....");
      return;
    }
    axios
      .post(`${process.env.REACT_APP_BACKEND_URL}/v1/rbac/get-route`, { route: rbacRoute, method }, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
      })
      .then((resp) => {
        const data = resp.data.data;
        const newState = Object.assign({}, inputs);
        newState.rbacId = data._id;
        newState.rbacRoute = data.route;
        newState.rbacEnabled = data.enabled;
        newState.rbacFree = data.free;
        newState.rbacMethod = data.method;
        newState.rbacRoles = data.rolesIds.join(",");
        setInputs(newState);
      })
      .catch((err) => handleAxiosError(err));
  };

  const postRbacs = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/rbac/`,
        {
          route: inputs.rbacRoute,
          method: inputs.rbacMethod,
          free: inputs.rbacFree || false,
          enabled: inputs.rbacEnabled || false,
          rolesIds: (inputs.rbacRoles && inputs.rbacRoles.split(",")) || [],
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        console.log(resp.data);
        globalContext.showModalWithMsg("Registrado");
        const data = resp.data.data.rbac;
        const newState = Object.assign({}, inputs);
        newState.rbacId = data._id;
        newState.rbacRoute = data.route;
        newState.rbacEnabled = data.enabled;
        newState.rbacFree = data.free;
        newState.rbacMethod = data.method;
        newState.rbacRoles = data.rolesIds.join(",");
        setInputs(newState);
      })
      .catch((err) => handleAxiosError(err));
  };

  const putRbac = () => {
    const rbacId = inputs.rbacId;

    if (!rbacId) {
      globalContext.showModalWithMsg("El ID...");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/v1/rbac/${rbacId}`,
        {
          route: inputs.rbacRoute,
          method: inputs.rbacMethod,
          free: inputs.rbacFree || false,
          enabled: inputs.rbacEnabled || false,
          rolesIds: (inputs.rbacRoles && inputs.rbacRoles.split(",")) || [],
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        console.log(resp.data);
        globalContext.showModalWithMsg("Actualizado");
        const data = resp.data.data.rbac;
        const newState = Object.assign({}, inputs);
        newState.rbacRoute = data.route;
        newState.rbacEnabled = data.enabled;
        newState.rbacFree = data.free;
        newState.rbacMethod = data.method;
        newState.rbacRoles = data.rolesIds.join(",");
        setInputs(newState);
      })
      .catch((err) => handleAxiosError(err));
  };

  const delRbac = () => {
    const rbacId = inputs.rbacId;

    if (!rbacId) {
      globalContext.showModalWithMsg("El ID...");
      return;
    }

    axios
      .delete(`${process.env.REACT_APP_BACKEND_URL}/v1/rbac/${rbacId}`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          "x-access-token": localStorage.getItem(keyAccessToken),
          "x-user-id": localStorage.getItem(keyUserId),
        },
      })
      .then((resp) => {
        console.log(resp.data);
        globalContext.showModalWithMsg("Eliminado");
      })
      .catch((err) => handleAxiosError(err));
  };

  const getDuplicatedReport = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-report/duplicated-titles`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
        globalContext.setLoaderPage(false);
        globalContext.showModalWithMsg("Se esjecuta en segundo plano");
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga del reporte."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const deleteDuplicatedTitle = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amaz-prod/delete-duplicated-titles`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        globalContext.setLoaderPage(false);
        console.log("data: ", data);
      })
      .catch((err) => {
        handleAxiosError(err, "Disculpe, no se pudo culminar.");
        globalContext.setLoaderPage(false);
      });
  };
  const weightToMl = () => {
    const entId = globalContext.currentEnterpriseId;

    if (!entId) {
      globalContext.showModalWithMsg("La empresa...");
      return;
    }
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amazon-report/weight-for-ml/${globalContext.currentEnterpriseId}`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
        globalContext.setLoaderPage(false);
        globalContext.showModalWithMsg("Se esjecuta en segundo plano");
      })
      .catch((err) => {
        handleAxiosError(
          err,
          "Disculpe, no se pudo culminar la descarga del reporte."
        );
        globalContext.setLoaderPage(false);
      });
  };

  const amazonPublishSimulation = () => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/v1/amaz-prod/simulate-publishing`,
        {
          prodIds: ["638e702c9b766e6b4986e998"],
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        console.log(resp.data);
      })
      .catch((err) => handleAxiosError(err));
  }

  const getNotifProcess = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/notif-process/`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
          params: {
            plugin: "odoo",
            productId: 114065,
            // productTemplateId: 123,
            // companyId: 123,
          }
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
      })
      .catch((err) => handleAxiosError(err, "Error"))
      .finally(() => globalContext.setLoaderPage(false));
  }

  const getApiDebug = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api-debug/60a59d4689ed925743259a78`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
      })
      .catch((err) => handleAxiosError(err, "Error"))
      .finally(() => globalContext.setLoaderPage(false));
  }

  const getMonitors = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/process-monitor/code/ODOO_SYNC_PRODUCTS_CRON`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
          params: {
            page: 1,
            limit: 5,
          }
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
      })
      .catch((err) => handleAxiosError(err, "Error"))
      .finally(() => globalContext.setLoaderPage(false));
  }

  const getApiDebugList = () => {
    globalContext.setLoaderPage(true);
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/v1/api-debug/`,
        {
          cancelToken: axiosCancelTokenSource.token,
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
          },
          params: {
            page: 1,
            limit: 5,
            // productId: 102617
            // sku: "asd"
            // enterpriseId: "5ee711224be87023ec455b94"
          }
        }
      )
      .then((resp) => {
        const data = resp.data.data;
        console.log(data);
      })
      .catch((err) => handleAxiosError(err, "Error"))
      .finally(() => globalContext.setLoaderPage(false));
  }

  const syncMlCategory = () => {
    const categoryId = inputs.mlCategoryId;
    const entId = globalContext.currentEnterpriseId;

    if (!entId) {
      globalContext.showModalWithMsg("La empresa es requerida");
      return;
    }

    if (!categoryId) {
      globalContext.showModalWithMsg("El ID de categoría ML es requerido");
      return;
    }

    globalContext.setLoaderPage(true);

    axios
      .put(
        `${process.env.REACT_APP_BACKEND_URL}/v1/ml-category/${entId}/sync-category`,
        {
          categoryId: categoryId,
        },
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            "x-access-token": localStorage.getItem(keyAccessToken),
            "x-user-id": localStorage.getItem(keyUserId),
            "Content-Type": "application/json",
          },
        }
      )
      .then((resp) => {
        console.log(resp.data);
        globalContext.showModalWithMsg("Sincronización de categoría ML exitosa");
      })
      .catch((err) => handleAxiosError(err))
      .finally(() => globalContext.setLoaderPage(false));
  };

  const addSupplierUserToAllProfiles = () => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) {
      globalContext.showModalWithMsg("La empresa es requerida");
      return;
    }

    const profileId = inputs.profileId;
    if (!profileId) {
      globalContext.showModalWithMsg("El ID del usuario es requerido");
      return;
    }

    globalContext.setLoaderPage(true);
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/odoo-owner/${entId}/add-supplier-user-to-all-profiles/${profileId}`, {}, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": localStorage.getItem(keyAccessToken),
        "x-user-id": localStorage.getItem(keyUserId),
        'Content-Type': 'application/json',
      }
    }).then(resp => {
      console.log(resp.data);
      globalContext.showModalWithMsg("Usuario agregado a todos los perfiles exitosamente");
    }).catch(err => handleAxiosError(err))
      .finally(() => globalContext.setLoaderPage(false));
  };

  const createSuppliersFromOwnerTotals = () => {
    const entId = globalContext.currentEnterpriseId;
    if (!entId) {
      globalContext.showModalWithMsg("La empresa es requerida");
      return;
    }

    globalContext.setLoaderPage(true);
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/v1/odoo-owner/${entId}/create-suppliers-from-owner-totals`, {}, {
      headers: {
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-access-token": localStorage.getItem(keyAccessToken),
        "x-user-id": localStorage.getItem(keyUserId),
        'Content-Type': 'application/json',
      }
    }).then(resp => {
      console.log(resp.data);
      globalContext.showModalWithMsg("Proveedores creados exitosamente");
    }).catch(err => handleAxiosError(err))
      .finally(() => globalContext.setLoaderPage(false));
  };

  useEffect(() => {
    const sections = ADMIN_TRACKED_SECTION_IDS.map((id) =>
      document.getElementById(id)
    ).filter(Boolean);

    if (!sections.length) return undefined;

    const getScrollContainer = (element) => {
      let parent = element.parentElement;

      while (parent) {
        const { overflowY } = window.getComputedStyle(parent);
        const isScrollable =
          /(auto|scroll|overlay)/.test(overflowY) &&
          parent.scrollHeight > parent.clientHeight;

        if (isScrollable) {
          return parent;
        }

        parent = parent.parentElement;
      }

      return window;
    };

    const scrollContainer = getScrollContainer(sections[0]);
    scrollContainerRef.current = scrollContainer;
    const scrollTargets =
      scrollContainer === window ? [window] : [window, scrollContainer];
    let ticking = false;

    const updateActiveSectionFromScroll = () => {
      if (isManualNavigationRef.current) return;

      const containerTop =
        scrollContainer === window
          ? 0
          : scrollContainer.getBoundingClientRect().top;
      const containerHeight =
        scrollContainer === window
          ? window.innerHeight
          : scrollContainer.clientHeight;
      const anchorPosition = containerTop + containerHeight * 0.24;

      let currentSectionId = sections[0].id;

      sections.forEach((section) => {
        const sectionTop = section.getBoundingClientRect().top;

        if (sectionTop <= anchorPosition) {
          currentSectionId = section.id;
        }
      });

      setActiveSection((prevSectionId) =>
        prevSectionId === currentSectionId ? prevSectionId : currentSectionId
      );
    };

    updateActiveSectionRef.current = updateActiveSectionFromScroll;

    const handleScroll = () => {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(() => {
        updateActiveSectionFromScroll();
        ticking = false;
      });
    };

    updateActiveSectionFromScroll();

    scrollTargets.forEach((target) => {
      target.addEventListener("scroll", handleScroll, {
        passive: true,
      });
    });
    window.addEventListener("resize", updateActiveSectionFromScroll);

    return () => {
      if (manualNavigationTimeoutRef.current) {
        window.clearTimeout(manualNavigationTimeoutRef.current);
      }

      setDisableNavTransition(false);

      scrollTargets.forEach((target) => {
        target.removeEventListener("scroll", handleScroll);
      });
      window.removeEventListener("resize", updateActiveSectionFromScroll);
    };
  }, []);

  const handleSectionNavigation = (sectionId) => {
    const sectionElement = document.getElementById(sectionId);

    if (!sectionElement) return;

    const scrollContainer = scrollContainerRef.current || window;
    const htmlElement = document.documentElement;
    const bodyElement = document.body;
    const previousHtmlScrollBehavior = htmlElement.style.scrollBehavior;
    const previousBodyScrollBehavior = bodyElement.style.scrollBehavior;
    const previousContainerScrollBehavior =
      scrollContainer !== window ? scrollContainer.style.scrollBehavior : null;

    isManualNavigationRef.current = true;
    setDisableNavTransition(true);

    if (manualNavigationTimeoutRef.current) {
      window.clearTimeout(manualNavigationTimeoutRef.current);
    }

    htmlElement.style.scrollBehavior = "auto";
    bodyElement.style.scrollBehavior = "auto";

    if (scrollContainer !== window) {
      scrollContainer.style.scrollBehavior = "auto";
    }

    sectionElement.scrollIntoView({
      behavior: "auto",
      block: "start",
      inline: "nearest",
    });

    manualNavigationTimeoutRef.current = window.setTimeout(() => {
      htmlElement.style.scrollBehavior = previousHtmlScrollBehavior;
      bodyElement.style.scrollBehavior = previousBodyScrollBehavior;

      if (scrollContainer !== window) {
        scrollContainer.style.scrollBehavior = previousContainerScrollBehavior;
      }

      isManualNavigationRef.current = false;
      updateActiveSectionRef.current();
      setDisableNavTransition(false);
    }, 40);
  };

  const layoutCardStyle = {
    background: "#ffffff",
    borderRadius: "24px",
    border: "1px solid rgba(15, 23, 42, 0.08)",
    boxShadow: "0 20px 45px rgba(15, 23, 42, 0.08)",
  };

  const sectionBaseStyle = {
    ...layoutCardStyle,
    padding: "1.75rem",
    marginBottom: "1.5rem",
    scrollMarginTop: "24px",
    transition: disableNavTransition
      ? "none"
      : "border-color 0.2s ease, box-shadow 0.2s ease",
  };

  const getSectionStyle = (sectionId) => {
    const theme = getNavTheme(sectionId);

    return {
      ...sectionBaseStyle,
      "--section-accent-color": theme.accent,
      border:
        isSectionActive(sectionId)
          ? "1px solid rgba(13, 110, 253, 0.35)"
          : sectionBaseStyle.border,
      boxShadow:
        isSectionActive(sectionId)
          ? "0 24px 50px rgba(13, 110, 253, 0.12)"
          : sectionBaseStyle.boxShadow,
    };
  };

  const isSectionActive = (sectionId) => {
    return ADMIN_SECTIONS.some((section) => {
      if (section.id !== sectionId) return false;

      const childIds = (section.children || []).map((child) => child.id);
      return activeSection === sectionId || childIds.includes(activeSection);
    });
  };

  const getNavTheme = (sectionId) =>
    NAV_SECTION_THEMES[sectionId] || NAV_SECTION_THEMES["section-sync"];

  const navButtonStyle = (sectionId, isActive, isChild = false) => {
    const theme = getNavTheme(sectionId);

    return {
      width: "100%",
      maxWidth: isChild ? "87%" : "100%",
      boxSizing: "border-box",
      border: "1px solid rgba(15, 23, 42, 0.08)",
      background: isActive
        ? theme.activeBackground
        : "#f8fafc",
      color: isActive ? theme.activeText : "#0f172a",
      borderRadius: "14px",
      padding: isChild ? "0.72rem 0.95rem 0.72rem 1.45rem" : "0.9rem 1rem",
      fontWeight: 600,
      textAlign: "left",
      transition: disableNavTransition ? "none" : "all 0.1s ease-in-out",
      boxShadow: isActive ? `0 16px 32px ${theme.shadow}` : "none",
      fontSize: isChild ? "0.92rem" : "1rem",
      marginLeft: 0,
      lineHeight: 1.3,
      whiteSpace: "normal",
      overflowWrap: "anywhere",
      wordBreak: "break-word",
    };
  };

  const subSectionStyle = {
    marginTop: "1rem",
    scrollMarginTop: "32px",
  };

  const DOWNLOAD_SUBSECTION_STYLES = {
    "section-downloads-odoo": {
      background: "linear-gradient(180deg, rgba(124, 123, 173, 0.22) 0%, rgba(109, 40, 217, 0.14) 100%)",
      titleColor: "#4c1d95",
    },
    "section-downloads-ml": {
      background: "linear-gradient(180deg, rgba(255, 230, 0, 0.34) 0%, rgba(245, 158, 11, 0.16) 100%)",
      titleColor: "#92400e",
    },
    "section-downloads-amazon": {
      background: "linear-gradient(180deg, rgba(255, 153, 0, 0.28) 0%, rgba(249, 115, 22, 0.14) 100%)",
      titleColor: "#9a3412",
    },
    "section-downloads-others": {
      background: "linear-gradient(180deg, rgba(100, 116, 139, 0.18) 0%, rgba(71, 85, 105, 0.12) 100%)",
      titleColor: "#334155",
    },
  };

  const getDownloadSubsectionStyle = (sectionId) => ({
    ...subSectionStyle,
    ...(DOWNLOAD_SUBSECTION_STYLES[sectionId] || {}),
  });

  const getDownloadSubsectionTitleStyle = (sectionId) => {
    const sectionStyle = DOWNLOAD_SUBSECTION_STYLES[sectionId];

    if (!sectionStyle) return undefined;

    return {
      color: sectionStyle.titleColor,
    };
  };

  return (
    <Container fluid className="test-admin-page py-4 px-lg-4 px-3">
      <style>{MODERN_ADMIN_STYLES}</style>
      {redirect}
      <div className="pt-3 mb-3">
        <h2>Herramientas</h2>
        <Row>
          <Col md={4}>
            <Link to="/admin/testing/tag-deleted-unsold">
              <Button variant="info" className="w-100">
                🏷️ Marcar Productos Sin Ventas
              </Button>
            </Link>
          </Col>
        </Row>
        <hr/>
      </div>
      <div
        style={{
          maxWidth: "1600px",
          margin: "0 auto",
        }}
      >
        <Row className="g-4">
          <Col xl={3} lg={4}>
            <div
              className="test-admin-sidebar"
              style={{
                ...layoutCardStyle,
                padding: "1.5rem",
                position: "sticky",
                top: "1.5rem",
              }}
            >
              <div className="mb-4">
                <div
                  style={{
                    fontSize: "0.8rem",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: "#64748b",
                    fontWeight: 700,
                    marginBottom: "0.5rem",
                  }}
                >
                  Admin Testing
                </div>
               

              </div>

              <div
                ref={navListRef}
                className="test-admin-sidebar-nav d-flex flex-column align-items-end"
                style={{ gap: "0.75rem" }}
              >
                {ADMIN_SECTIONS.map((section) => (
                  <React.Fragment key={section.id}>
                    <button
                      data-nav-id={section.id}
                      type="button"
                      onClick={() => handleSectionNavigation(section.id)}
                      style={navButtonStyle(section.id, isSectionActive(section.id))}
                    >
                      {section.label}
                    </button>

                    {(section.children || []).map((child) => (
                      <button
                        key={child.id}
                        data-nav-id={child.id}
                        type="button"
                        onClick={() => handleSectionNavigation(child.id)}
                        style={navButtonStyle(child.id, activeSection === child.id, true)}
                      >
                        {child.label}
                      </button>
                    ))}
                  </React.Fragment>
                ))}
              </div>
            </div>
          </Col>

          <Col xl={9} lg={8}>
            <div
              className="test-admin-hero"
              style={{
                ...layoutCardStyle,
                padding: "1.75rem",
                marginBottom: "1.5rem",
                background:
                  "linear-gradient(135deg, rgba(13, 110, 253, 0.08) 0%, rgba(111, 66, 193, 0.05) 100%)",
              }}
            >
              <h1
                style={{
                  fontSize: "2rem",
                  fontWeight: 700,
                  color: "#0f172a",
                  marginBottom: "0.65rem",
                }}
              >
                Herramientas de administracion
              </h1>
              
            </div>

            <div
              id="section-sync"
              className="test-admin-section"
              style={getSectionStyle("section-sync")}
            >
              <h2 className="test-admin-section-title">Sincronizar</h2>
              <Row>
      
          <Col md={3}>
                  <Button className="w-100" onClick={syncCurrencies}>
                    Sicronizar monedas
                  </Button>
                </Col>

                <Col md={3}>
                  <Button className="w-100" onClick={syncCountries}>
                    Sincronizar países{" "}
                  </Button>
                </Col>
              </Row>
            </div>

            <div
              id="section-downloads"
              className="test-admin-section"
              style={getSectionStyle("section-downloads")}
            >
              <Form className="mt-0" direction="vertical" gap={15}>
                <h2 className="test-admin-section-title">Descargas</h2>
                <div
                  id="section-downloads-odoo"
                  className="test-admin-subsection mt-4"
                  style={getDownloadSubsectionStyle("section-downloads-odoo")}
                >
                  <h5
                    className="test-admin-subsection-title"
                    style={getDownloadSubsectionTitleStyle("section-downloads-odoo")}
                  >
                    Odoo
                  </h5>
                  <Row
                    className="mb-4 d-flex align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    <Col md={5}>
                      <Button className="w-100" onClick={() => downloadAllImg()}>
                        Descargar todas las imagenes de odoo
                      </Button>
                    </Col>
                    <Col md={5}>
                      <Button
                        className="w-100"
                        onClick={() => downloadAllImgVariants()}
                      >
                        Descargar todas las imagenes de odoo Variantes
                      </Button>
                    </Col>
                    <Col md={5}>
                      <Button
                        className="w-100"
                        onClick={() => downloadAllImgProduct()}
                      >
                        Descargar todas las imagenes de odoo Productos
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col md={3}>
                      <Button
                        className="w-100"
                        onClick={() => downloadodooCategories()}
                      >
                        Descargar Cat odoo
                      </Button>
                    </Col>
                    <Col md={5}>
                      <Button className="w-100" onClick={donwloadAttrOdoo}>
                        Descargar atributos de Odoo
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                </div>
                <div
                  id="section-downloads-ml"
                  className="test-admin-subsection mt-4"
                  style={getDownloadSubsectionStyle("section-downloads-ml")}
                >
                  <h5
                    className="test-admin-subsection-title"
                    style={getDownloadSubsectionTitleStyle("section-downloads-ml")}
                  >
                    Mercado Libre
                  </h5>
                  <Row>
                    <Col md={6} className="d-flex" style={{ alignItems: "center" }}>
                      <Form.Control
                        type="text"
                        placeholder="País ML"
                        name="mlCountry"
                        value={inputs.mlCountry || ""}
                        onChange={updateInputState}
                        className="w-100"
                      />
                      <Button className="w-100" onClick={downloadCategories}>
                        Descargar Categorias ML
                      </Button>
                    </Col>
                    <Col md={2}>
                      <Button className="w-100" onClick={weightToMl}>
                        weightToMl
                      </Button>
                    </Col>
                    <Col md={4}>
                      <Button
                        className="bg-success border-0"
                        onClick={updateMlUsers}
                      >
                        Update ML Users
                      </Button>
                    </Col>
                  </Row>
                  <Row
                    className="mt-3"
                  >
                    <Col
                      md={8}
                      className="d-flex"
                    >
                      <Form.Control
                        type="text"
                        placeholder="ID Categoría ML (ej: MLV457909)"
                        name="mlCategoryId"
                        value={inputs.mlCategoryId || ""}
                        onChange={updateInputState}
                        className="w-100"
                      />
                      <Button className="w-100" onClick={syncMlCategory}>
                        Sincronizar Categoría ML
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                </div>
                <div
                  id="section-downloads-amazon"
                  className="test-admin-subsection mt-4"
                  style={getDownloadSubsectionStyle("section-downloads-amazon")}
                >
                  <h5
                    className="test-admin-subsection-title"
                    style={getDownloadSubsectionTitleStyle("section-downloads-amazon")}
                  >
                    Amazon
                  </h5>
                  <Row style={{ gap: "1rem" }}>
                    <Col md={8}  className="d-flex" >
                      <Form.Control
                        type="text"
                        placeholder="Num Niveles"
                        name="numAmazonLevel"
                        value={inputs.numAmazonLevel || ""}
                        onChange={updateInputState}
                        className="w-100"
                      />
                      <Button onClick={downloadAmazonCategories} className="w-100">
                        Descargar Categorias Amazon
                      </Button>
                    </Col>
                    <Col md={10}>
                      <div className="d-flex" style={{ gap: "1rem" }}>
                        <input
                          size="md"
                          placeholder="Pagina"
                          name="pagina"
                          onChange={(e) => setPageReport(e.target.value)}
                          className="w-100 form-control"
                        />
                        <input
                          size="sm"
                          placeholder="Limite por paginal"
                          name="total"
                          onChange={(e) => setLimitReport(e.target.value)}
                          className="w-100 form-control"
                        />
                      </div>
                      <Button className="w-100" onClick={getDataPrice}>
                        Obtener datos de precios
                      </Button>
                    </Col>
                    <Col md={9} className="flex">
                      <div>
                        Fecha reporte:
                        <DateTime
                          setValue={setDateReportUrl}
                          valueDefaultText="Fecha Desde"
                        />
                      </div>

                      <div className="d-flex" style={{ gap: "2rem" }}>
                        <Button className="w-100" onClick={getScrapedReport}>
                          Descargar reporte de scrapeados
                        </Button>
                        <Button className="w-100" onClick={getRescrapedReport}>
                          Descargar reporte de rescrapeados
                        </Button>
                      </div>
                    </Col>

                    <Col md={10} className="d-flex">
                      <Form.Control
                        type="text"
                        placeholder="entWeigth"
                        name="entWeigth"
                        value={inputs.entWeigth || ""}
                        onChange={updateInputState}
                        className="w-100"
                      />
                      <Button className="w-75" onClick={amazonPublishSimulation}>
                        Simulación de publicación de Amazon
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                </div>

                <div
                  id="section-downloads-others"
                  className="test-admin-subsection"
                  style={getDownloadSubsectionStyle("section-downloads-others")}
                >
                  <h5
                    className="test-admin-subsection-title"
                    style={getDownloadSubsectionTitleStyle("section-downloads-others")}
                  >
                    Otros
                  </h5>
                  <Row
                    className="mb-4 d-flex align-items-center"
                    style={{ gap: "1rem" }}
                  >
                    <Col md={3}>
                      <Button
                        className="w-100"
                        onClick={() => downloadCategoriesAnican()}
                      >
                        Braands Anican
                      </Button>
                    </Col>
                    <Col md={3}>
                      <Button className="w-100" onClick={freeShipping}>
                        Envío gratis
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-4 d-flex align-items-center">
                    <Col md={2}>
                      <Button
                        className="bg-danger border-0"
                        onClick={() => removeBackground()}
                      >
                        Limpiar imagenes
                      </Button>
                    </Col>
                    <Col md={2}>
                      <Button className="bg-secondary border-0" onClick={lodeml}>
                        Traducir titulos
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Form>
            </div>

            <div
              id="section-scrapping"
              className="test-admin-section"
              style={getSectionStyle("section-scrapping")}
            >
              <h2 className="test-admin-section-title">Scrapping</h2>
              <Row style={{ gap: "1rem" }}>
                <Col md={3}>
                  <Button
                    className="w-100 bg-secondary border-0"
                    onClick={fixScrapMl}
                  >
                    <del>fixScrapMl</del>¿?
                  </Button>
                </Col>
                <Col md={3}>
                  <Button className="w-100" onClick={startAmazonScrapCron}>
                    Start Amazon Scrap Cron
                  </Button>
                </Col>
                <Col md={4}>
                  <Button className="w-100" onClick={scrapedVariantToProduct}>
                    Variante escrapeada a producto
                  </Button>
                </Col>
                <Col md={8} className="d-flex flex-column align-items-center">
                  <Form.Control
                    size="sm"
                    as="textarea"
                    placeholder="Config"
                    name="amazonScrapConfig"
                    value={inputs.amazonScrapConfig || ""}
                    onChange={updateInputState}
                    className="w-100"
                  />
                  <div
                    className="d-flex w-100 justity-content-between"
                    style={{ gap: "2rem" }}
                  >
                    <Button className="w-75" onClick={getAmazonScrapConfig}>
                      GetAmazonScrapConfig
                    </Button>
                    <Button className="w-75" onClick={setAmazonScrapConfig}>
                      SetAmazonScrapConfig
                    </Button>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="d-flex justify-content-between ">
                    <Form.Control
                      type="text"
                      placeholder="ID categoria Amazon"
                      name="categoryToScrap"
                      value={inputs.categoryToScrap || ""}
                      onChange={updateInputState}
                      className="w-50 mr-2"
                    />
                    <Form.Control
                      type="text"
                      placeholder="Cantidad Productos"
                      name="numProdToScrapFromCategory"
                      value={inputs.numProdToScrapFromCategory || ""}
                      onChange={updateInputState}
                      className="w-50 me-2"
                    />
                  </div>
                  <Button onClick={scrapAmazonCategoryNode} className="w-100">
                    Scrap
                  </Button>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={4}>
                  <Button className="bg-danger border-0 w-100" onClick={delNoUrl}>
                    Eliminar productos sin url
                  </Button>
                </Col>
              </Row>
            </div>

            <div
              id="section-nord"
              className="test-admin-section"
              style={getSectionStyle("section-nord")}
            >
              <h2 className="test-admin-section-title">Nord</h2>
              <Row>
                <Col md={3}>
                  <Button className="w-100" onClick={syncNordServers}>
                    Sync Nord Servers
                  </Button>
                </Col>
                <Col md={3}>
                  <Button className="w-100" onClick={nordVpnUser}>
                    Smart Proxies
                  </Button>
                </Col>
              </Row>
            </div>

            <div
              id="section-proxies"
              className="test-admin-section"
              style={getSectionStyle("section-proxies")}
            >
              <h2 className="test-admin-section-title">Cuentas Proxys</h2>
              <Row
                className="mb-4 d-flex align-items-center"
                style={{ gap: "1rem" }}
              >
                <Col md={4}>
                  <Button className="w-100" onClick={addProxyAcc}>
                    Añadir cuenta proxy
                  </Button>
                </Col>
                <Col md={4}>
                  <Button className="w-100" onClick={updateProxyAcc}>
                    Actualizar cuenta proxy
                  </Button>
                </Col>
                <Col md={4}>
                  <Button className="w-100" onClick={getProxyAcc}>
                    Obtener cuenta de proxy
                  </Button>
                </Col>

                <Col md={8}>
                  <div className="d-flex" style={{ gap: "1rem" }}>
                    <Form.Control
                      size="sm"
                      placeholder="ProxyAcc Mongo ID"
                      name="proxyAccId"
                      value={inputs.proxyAccId || ""}
                      onChange={updateInputState}
                      className="form-control"
                    />
                    <Form.Control
                      size="sm"
                      placeholder="ProxyAcc User"
                      name="proxyAccUser"
                      value={inputs.proxyAccUser || ""}
                      onChange={updateInputState}
                      className="form-control"
                    />
                    <Form.Control
                      size="sm"
                      placeholder="ProxyAcc Pass"
                      name="proxyAccPass"
                      value={inputs.proxyAccPass || ""}
                      onChange={updateInputState}
                      className="form-control"
                    />
                  </div>
                  <Button className="w-100" onClick={disableProxyAcc}>
                    Deshabilitar cuenta proxy
                  </Button>
                </Col>
              </Row>
            </div>

            <div
              id="section-debugging"
              className="test-admin-section"
              style={getSectionStyle("section-debugging")}
            >
              <h2 className="test-admin-section-title">Process debugging</h2>
              <Row
                className="mt-4 mb-0 d-flex align-items-center"
                style={{ gap: "1rem" }}
              >
                <Col md={5}>
                  <Link to="/admin/api-debug/products" className="test-admin-debug-link">
                    <Button
                      className="w-100 py-2"
                    >
                      Api Debug
                    </Button>
                  </Link>
                </Col>
                <Col md={5}>
                  <Link to="/admin/process-monitor" className="test-admin-debug-link">
                    <Button
                      className="w-100 py-2"
                    >
                      Process Monitor Debug
                    </Button>
                  </Link>
                </Col>
                <Col md={5}>
                  <Link to="/admin/notification-process" className="test-admin-debug-link">
                    <Button
                      className="w-100 py-2"
                    >
                      Notification Process Debug
                    </Button>
                  </Link>
                </Col>
                <Col md={5}>
                  <Link to="/admin/cron-status" className="test-admin-debug-link">
                    <Button
                      className="w-100 py-2"
                    >
                      Cron Debug
                    </Button>
                  </Link>
                </Col>
                <Col md={3}>
            <Link to='/admin/product-linked-logs'>
              <Button className="w-100" >
                Ir a Logs Sync/Desync
              </Button>
            </Link>
          </Col>
        </Row>
            </div>

      {/* <Form className="mt-3" direction="vertical" gap={15}>
                <Row className="mb-4 d-flex align-items-center">
                    <Col>
                        <Button onClick={() => downloadAllImg()}>
                            Descargar todas las imagenes de odoo
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => downloadAllImgVariants()}>
                            Descargar todas las imagenes de odoo Variantes
                        </Button>
                    </Col>
                    <Col>
                        <Button onClick={() => downloadAllImgProduct()}>
                            Descargar todas las imagenes de odoo Productos
                        </Button>
                    </Col>
                </Row>
                <Row className="mb-4 d-flex align-items-center">
                    <Col md={3}>
                        <Button onClick={() => testKeepa()}>
                            Test Keepa
                        </Button>
                    </Col>
                    <Col md={3}>
                        <Button onClick={() => downloadodooCategories()}>
                            Descargar Cat odoo
                        </Button>
                    </Col>
                    <Col md={3}>
                        <Button onClick={() => testJesus()}>sync categories ali</Button>
                    </Col>
                    <Col md={3}>
                        <Button onClick={() => sendCategoriesWoo()}>Enviar categorias Woo</Button>
                    </Col>
                </Row>

                <Row className="mb-4 d-flex align-items-center">
                    <Col md={3}>
                        <Button onClick={() => removeBackground()}>Limpiar imagenes</Button>
                    </Col>
                    <Col md={3}>
                        <Button onClick={() => downloadCategoriesAnican()}>Braands Anican</Button>
                    </Col>
                    <Col md={3}>

                        <Button onClick={() => sendMlProd()}>Publica ml odoo ML</Button>
                    </Col>
                    <Col md={3}>
                        <Form.Control
                            type="text"
                            placeholder="País ML"
                            name="mlCountry"
                            value={inputs.mlCountry || ""}
                            onChange={updateInputState}
                        />
                        <Button onClick={downloadCategories} className="w-1">Descargar Categorias ML</Button>
                    </Col>
                    <Col md={12} className="my-4">
                        <Row>
                            <Col md={5} >
                                <Form.Control
                                    type="text"
                                    placeholder="Num Niveles"
                                    name="numAmazonLevel"
                                    value={inputs.numAmazonLevel || ""}
                                    onChange={updateInputState}
                                    className="w-100"
                                />
                                <Button onClick={downloadAmazonCategories} className="w-100">Descargar Categorias Amazon</Button>
                            </Col>
                            <Col md={7}>
                                <div className="d-flex justify-content-between "> <Form.Control
                                    type="text"
                                    placeholder="ID categoria Amazon"
                                    name="categoryToScrap"
                                    value={inputs.categoryToScrap || ""}
                                    onChange={updateInputState}
                                    className="w-50 mr-2"
                                />
                                    <Form.Control
                                        type="text"
                                        placeholder="Cantidad Productos"
                                        name="numProdToScrapFromCategory"
                                        value={inputs.numProdToScrapFromCategory || ""}
                                        onChange={updateInputState}
                                        className="w-50 me-2"
                                    /></div>
                                <Button onClick={scrapAmazonCategoryNode} className="w-100">Scrap</Button>
                            </Col>
                        </Row>
                    </Col>

                </Row>

                <Row className="mb-4 d-flex align-items-center">
                    <Col md={2}>
                        <Button onClick={updateMlUsers}>Update ML Users</Button>
                    </Col>

                    <Col md={2}>
                        <Button onClick={fixScrapMl}>fixScrapMl</Button>
                    </Col>

                    <Col md={2}>
                        <Button onClick={syncCurrencies}>syncCurrencies</Button>
                    </Col>

                    <Col md={2}>
                        <Button onClick={syncCountries}>syncCountries</Button>
                    </Col>
                </Row>


                <Row className="mb-4 d-flex align-items-center">
                    <Col md={2}>
                        <Button onClick={startAmazonScrapCron}>Start Amazon Scrap Cron</Button>
                    </Col>

                    <Col md={2}>
                        <Button onClick={syncNordServers}>Sync Nord Servers</Button>
                    </Col>

                    <Col md={2}>
                        <Button onClick={nordVpnUser}>NordVpnUser</Button>
                    </Col>
                </Row>

                <Row className="mb-4 d-flex align-items-center">
                    <Col md={3}>
                        <Button onClick={getAmazonScrapConfig}>GetAmazonScrapConfig</Button>
                        <Button onClick={setAmazonScrapConfig}>SetAmazonScrapConfig</Button>
                    </Col>

                    <Col md={9}>
                        <Form.Control
                            size="sm"
                            as="textarea"
                            placeholder="Config"
                            name="amazonScrapConfig"
                            value={inputs.amazonScrapConfig || ""}
                            onChange={updateInputState}
                        />
                    </Col>
                </Row>

                <Row className="mb-4 d-flex align-items-center">
                    <Col md={2}>
                        <Button onClick={scrapedVariantToProduct}>scrapedVariantToProduct</Button>
                    </Col>
                </Row>

                <Row className="mb-4 d-flex align-items-center">
                    <Col md={2}>
                        <Button onClick={addProxyAcc}>addProxyAcc</Button>
                    </Col>
                    <Col md={2}>
                        <Button onClick={updateProxyAcc}>updateProxyAcc</Button>
                    </Col>
                    <Col md={2}>
                        <Button onClick={getProxyAcc}>getProxyAcc</Button>
                    </Col>
                    <Col md={2}>
                        <Button onClick={disableProxyAcc}>disableProxyAcc</Button>
                    </Col>
                    <Col md={4}>
                        <Form.Control
                            size="sm"
                            placeholder="ProxyAcc Mongo ID"
                            name="proxyAccId"
                            value={inputs.proxyAccId || ""}
                            onChange={updateInputState}
                        />
                        <Form.Control
                            size="sm"
                            placeholder="ProxyAcc User"
                            name="proxyAccUser"
                            value={inputs.proxyAccUser || ""}
                            onChange={updateInputState}
                        />
                        <Form.Control
                            size="sm"
                            placeholder="ProxyAcc Pass"
                            name="proxyAccPass"
                            value={inputs.proxyAccPass || ""}
                            onChange={updateInputState}
                        />
                    </Col>
                </Row>

                <Row className="mb-4 d-flex align-items-center">
                    <Col md={2}>
                        <Button onClick={delNoUrl}>delNoUrl</Button>
                    </Col>
                    <Col md={2}>
                        <Button onClick={lodeml}>Traducir titulos</Button>
                    </Col>
                    <Col md={2}>
                        <Button onClick={freeShipping}>Free shipping</Button>
                    </Col>
                </Row>
                <Row>
                    <Col md={2}>
                        <Button onClick={getDataPrice}>getDataPrice</Button>
                    </Col>
                    <Col md={2}>
                        <input
                            size="sm"
                            placeholder="Pagina"
                            name="pagina"
                            onChange={(e) => setPageReport(e.target.value)}
                        />
                    </Col>
                    <Col md={2}>
                        <input
                            size="sm"
                            placeholder="Limite por paginal"
                            name="total"
                            onChange={(e) => setLimitReport(e.target.value)}
                        />
                    </Col>
                </Row>
            </Form> */}
            <div
              id="section-rbac"
              className="test-admin-section"
              style={getSectionStyle("section-rbac")}
            >
              <h2 className="test-admin-section-title">RBAC</h2>

              <Row className="mb-4 d-flex align-items-center">
                <Col md={5} className="d-flex flex-column" style={{ gap: ".3rem" }}>
                  <Form.Control
                    size="sm"
                    placeholder="Rbac ID"
                    name="rbacId"
                    value={inputs.rbacId || ""}
                    onChange={updateInputState}
                  />
                  <Form.Control
                    size="sm"
                    placeholder="Rbac route"
                    name="rbacRoute"
                    value={inputs.rbacRoute || ""}
                    onChange={updateInputState}
                  />
                  <Form.Switch
                    label="Rbac enabled"
                    name="rbacEnabled"
                    id="rbacEnabled"
                    checked={inputs.rbacEnabled || false}
                    onChange={updateInputState}
                  />
                  <Form.Switch
                    label="Rbac free"
                    name="rbacFree"
                    id="rbacFree"
                    checked={inputs.rbacFree || false}
                    onChange={updateInputState}
                  />
                  <Form.Control
                    size="sm"
                    placeholder="Rbac method"
                    name="rbacMethod"
                    value={inputs.rbacMethod || ""}
                    onChange={updateInputState}
                  />
                  <Form.Control
                    as="textarea"
                    size="sm"
                    placeholder="Rbac roles"
                    name="rbacRoles"
                    value={inputs.rbacRoles || ""}
                    onChange={updateInputState}
                  />
                </Col>
                <Col md={3} className="d-flex flex-column" style={{ gap: "1rem" }}>
                  <Button className="w-100" onClick={getRbacs}>
                    Obtener todos los RBACS
                  </Button>
                  <Button className="w-100" onClick={getRbac}>
                    Obtener RBAC
                  </Button>
                  <Button className="w-100" onClick={postRbacs}>
                    Publicar RBAC
                  </Button>
                  <Button className="w-100" onClick={putRbac}>
                    Actualizar RBAC
                  </Button>
                  <Button className="w-100" onClick={delRbac}>
                    Eliminar RBAC
                  </Button>
                </Col>
              </Row>
              <Row className="mb-0 d-flex align-items-center">
                <Col md={6}>
                  <Button onClick={getDuplicatedReport}>
                    Obtener informe duplicado
                  </Button>
                </Col>
              </Row>
            </div>

            <div
              id="section-others"
              className="test-admin-section"
              style={getSectionStyle("section-others")}
            >
              <h2 className="test-admin-section-title">Otros</h2>
              <Row>
                <Col md={4}>
                  <Button className="w-100" onClick={() => testKeepa()}>
                    Test Keepa
                  </Button>
                </Col>
                <Col md={4}>
                  <Button className="w-100" onClick={() => sendCategoriesWoo()}>
                    Enviar categorias Woo
                  </Button>
                </Col>
                <Col md={3}>
                  <Button className="w-100" onClick={() => sendMlProd()}>
                    Publica ml odoo ML
                  </Button>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={3}>
                  <Button className="w-100" onClick={() => getNotifProcess()}>
                    getNotifProcess
                  </Button>
                </Col>
                <Col md={3}>
                  <Button className="w-100" onClick={() => getApiDebug()}>
                    getApiDebugById
                  </Button>
                </Col>
                <Col md={3}>
                  <Button className="w-100" onClick={() => getApiDebugList()}>
                    getApiDebugList
                  </Button>
                </Col>
                <Col md={3}>
                  <Button className="w-100" onClick={() => getMonitors()}>
                    getMonitors
                  </Button>
                </Col>
              </Row>
              <Row className="mt-3">
                <Col md={4}>
                  <Link to="/admin/odoo-brands-admin">
                    <Button className="w-100" variant="info">
                      Administrar Marcas
                    </Button>
                  </Link>
                </Col>
              </Row>
            </div>

            <div
              id="section-odoo-owner"
              className="test-admin-section"
              style={getSectionStyle("section-odoo-owner")}
            >
              <h2 className="test-admin-section-title">
                Odoo Owner - Proveedores
              </h2>
              <Row className="mt-3">
                <Col md={6}>
                  <Form.Control
                    size="sm"
                    type="text"
                    placeholder="ID de Usuario a Agregar"
                    name="profileId"
                    value={inputs.profileId || ""}
                    onChange={updateInputState}
                    className="mb-2"
                  />
                  <Button onClick={addSupplierUserToAllProfiles} className="w-100">
                    Agregar Usuario a Todos los Perfiles
                  </Button>
                </Col>
                <Col md={6}>
                  <Button
                    onClick={createSuppliersFromOwnerTotals}
                    className="w-100"
                  >
                    Crear Proveedores desde Owner Totals
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
